import { SwiperProps } from 'swiper/react'
import { Grid } from 'swiper/modules'
import { Swiper } from 'swiper/types'
import { RowType } from './Swimlane.types'

export const getSwiperProps = (
  setSwiperInstance: (swiper: Swiper) => void,
  spaceBetween: number | undefined,
  showAsGrid: boolean,
  rowType: RowType
) => {
  const swiperProps: SwiperProps = {
    onSwiper: (swiper: Swiper) => {
      setSwiperInstance(swiper)
    },
    allowTouchMove: true,
    watchSlidesProgress: true,
    navigation: false
  }

  if (spaceBetween || spaceBetween === 0) {
    swiperProps.spaceBetween = spaceBetween
  }

  if (rowType === RowType.DOUBLE) {
    swiperProps.allowTouchMove = !showAsGrid
    swiperProps.spaceBetween = 16

    if (showAsGrid) {
      swiperProps.modules = [Grid]
      swiperProps.slidesPerView = 4
      swiperProps.grid = {
        rows: 2
      }
    } else {
      swiperProps.slidesPerView = 'auto'
    }
  }
  return swiperProps
}
